<template>
  <div id="preview" v-if="prods">
    <div class="printTitle">{{date}} {{label}}</div>
    <div class="printCount">
      <div></div>
      <div>種類: {{prods.length}} 種</div>
      <div>品項: {{[].concat(...prods.map(e => e.items)).length}} 項</div>
      <div>總數量: {{[].concat(...prods.map(e => e.items)).map(e => e.count).reduce((a, b) => a + b, 0)}} 個</div>
      <div></div>
    </div>
    <div class="printBody">
      <div class="eachItem" v-for="(row, r) in prods" :key="r">
        <div>
          <div>{{row._id}}</div>
          <div>共計: {{row.items.map(e => e.count).reduce((a, b) => a + b, 0)}} 組/個</div>
        </div>
        <div class="tableTitle">
          <div>商品名稱</div>
          <div>數量</div>
        </div>
        <div v-for="(item, i) in row.items" :key="`item-${r}-${i}`">
          <div>{{item.name}}</div>
          <div>{{item.count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['prods', 'label', 'date']

}
</script>
<style>
:root {
  --fonts11: calc(11mm * 0.4);
  --fonts12: calc(12mm * 0.4);
  --fonts14: calc(14mm * 0.4);
  --fonts16: calc(16mm * 0.4);
  --fonts18: calc(18mm * 0.4);
}
</style>
<style scoped>
.printTitle {
  font-size: var(--fonts18);
  text-align: center;
  margin-inline: auto;
  letter-spacing: .2em;
}
.printBody {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}
.printCount {
  display: flex;
  border: 1px solid #000000;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 15px;
  font-size: var(--fonts14);
  line-height: 1.8em;
  margin-top: 15px;
}
.eachItem {
  border: 1px solid #000000;
}
.eachItem>div {
  display: flex;
  padding-inline: 15px;
  align-items: center;
  justify-content: space-between;
  font-size: var(--fonts14);
  line-height: 2.8em;
  font-weight: 500;
}
.eachItem>div:nth-child(1) {
  border-bottom: 1px solid;
  line-height: 2em;
  font-weight: 400;
}
.eachItem>div:nth-child(2) {
  line-height: 2em;
  font-size: var(--fonts12);
  color: #FFFFFF;
  background-color: #8C8C8C;
  font-weight: 400;
}

</style>
<style scoped>
#preview {
  position: fixed;
  top: 90px;
  left: calc(70px + 100vw);
  /* left: 70px; */
  width: 210mm;
  height: 297mm;
  background-color: #FFFFFF;
  z-index: 100;
  overflow-y: auto;
  padding: 10mm;
}
</style>
